import { makeAutoObservable } from "mobx";

export type RandomSpaceAccessPublicConfig = {
  enabled: boolean;
  candidates: string[];
  /** 是否显示粉色大按钮；关闭则为轻文字 */
  bigButton: boolean;
  /** 按钮文案；空则默认「为我推荐」 */
  buttonText: string;
};

export const DEFAULT_RANDOM_ENTER_BUTTON_TEXT = "为我推荐";

export function resolveRandomEnterButtonText(buttonText?: string | null): string {
  const t = (buttonText ?? "").trim();
  return t || DEFAULT_RANDOM_ENTER_BUTTON_TEXT;
}

export class HomeModel {
  spaceIdInput = "";
  /** 空间 ID 校验失败时展示，如：您输入的空间ID不存在 */
  entranceError: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setSpaceIdInput(v: string) {
    this.spaceIdInput = v.replace(/\D/g, "").slice(0, 8);
    this.entranceError = null;
  }

  setEntranceError(msg: string | null) {
    this.entranceError = msg;
  }

  get isValidSpaceId(): boolean {
    return /^\d{8}$/.test(this.spaceIdInput);
  }
}
